/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'd-arrow-up': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M474.3 480.7L113.9 836.6c-20.2 19-21.2 50.7-2.3 71 .7.8 1.5 1.5 2.3 2.3 9.5 10.4 23 16.1 37.1 15.7 14.1.4 27.6-5.3 37.1-15.7l323.3-319.1 323.3 319.1c9.5 10.4 23.1 16.1 37.1 15.7 14.1.4 27.6-5.3 37.1-15.7 20.2-19 21.2-50.7 2.3-71-.7-.8-1.5-1.5-2.3-2.3L548.5 480.7c-19.9-20.5-52.6-21-73.1-1.1-.4.3-.8.7-1.1 1.1zm0-366.3L113.9 470.2c-20.2 19-21.2 50.7-2.3 71 .7.8 1.5 1.5 2.3 2.3 9.5 10.4 23 16.1 37.1 15.7 14.1.4 27.6-5.3 37.1-15.6l323.3-319.2 323.3 319.2c9.5 10.4 23.1 16.1 37.1 15.6 14 .4 27.6-5.3 37.1-15.6 20.2-19 21.2-50.7 2.3-71-.7-.8-1.5-1.5-2.3-2.3L548.5 114.4c-19.9-20.5-52.6-21-73.1-1.1l-1.1 1.1z"/>'
  }
})
